export interface RoleDescription {
  /** Short description used in form helpers and tooltips */
  short: string;
  /** Long description used in role selection and help documentation */
  long: string;
  /** Optional field for repository description */
  repository?: string;
  /** Optional field for policy collection description */
  ["policy-collection"]?: string;
  /** Optional field for account group description */
  ["account-group"]?: string;
}

export interface Role {
  /** Role description containing short and long text */
  description: RoleDescription;
}

export const ROLES: Record<
  | "stacklet-user"
  | "viewer"
  | "resource-viewer"
  | "creator"
  | "editor"
  | "policy-deployer"
  | "owner"
  | "admin",
  Role
> = {
  "stacklet-user": {
    description: {
      short:
        "Users can login to any Stacklet App - Console, AssetDB, IaC Governance, Jun0",
      long: "Users can login to any Stacklet App - Console, AssetDB, IaC Governance, Jun0",
    },
  },
  viewer: {
    description: {
      short:
        "Users can view Stacklet objects - Policies, Policy Collections, Policy Repositories",
      long: "Users can view Stacklet objects - Policies, Policy Collections, Policy Repositories",
    },
  },
  "resource-viewer": {
    description: {
      short:
        "Users can view resources and resource matches for resources in any account in Stacklet",
      long: "Users can view resources and resource matches for resources in ALL or select Account Group(s) in Stacklet",
      "account-group":
        "Can view resources and resource matches for all accounts in this group",
    },
  },
  creator: {
    description: {
      short:
        "Users can create Account Groups and Policy Collections, and add Policy Repositories",
      long: "Users can create Account Groups and/or Policy Collections, and/or add Policy Repositories",
    },
  },
  editor: {
    description: {
      short:
        "Users can view, edit, remove, and view-acl for all Account Groups, Policy Collections, and Policy Repositories",
      long: "Users can view, edit, remove, and view-acl for Account Groups, Policy Collections, and/or Policy Repositories",
      repository: "Can add, remove, and edit this repository",
      "policy-collection":
        "Can view, edit, remove, and view-acl for this policy collection",
      "account-group":
        "Can view, edit, remove, and view-acl for this account group",
    },
  },
  "policy-deployer": {
    description: {
      short:
        "User can view resources and resource matches, and deploy policies against all Account Group(s) in Stacklet",
      long: "User can view resources and resource matches, and deploy policies against ALL or select Account Group(s) in Stacklet",
      "account-group":
        "Can view resources and resource matches in, and deploy policies to this account group",
    },
  },
  owner: {
    description: {
      short:
        "Users can view, edit, remove, view-acl, and edit-acl for all Account Groups, Policy Collections, and Policy Repositories ",
      long: "User can view, edit, remove, view-acl, edit-acl on ALL or select Account Groups, Policy Collections, and/or Repositories",
      repository: "Can modify repository permissions, details, and policies",
      "policy-collection":
        "Can view, edit, remove, view-acl, and edit-acl for this policy collection",
      "account-group":
        "Can view, edit, remove, view-acl, and edit-acl for this account group",
    },
  },
  admin: {
    description: {
      short: "User has all permissions (admin permissions)",
      long: "User has all permission (admin permissions)",
    },
  },
};
